<template>
  <div class="layout" id="myComponentDiv">
    <div class="box-titulo">Reporte de Corte por Día</div>
    <div class="box-container">
      <div class="box-filtres">
        <table>
          <tbody>
            <tr>
              <td width="150px">
                <input
                  id="fechainicio"
                  placeholder="Fecha inicio"
                  datatype="fecha"
                  type="text"
                  class="form-control"
                  autocomplete="off"
                  v-on:change="trigger()"
                />
              </td>
              <td width="150px">
                <input
                  id="fechafinal"
                  placeholder="Fecha final"
                  datatype="fecha"
                  type="text"
                  class="form-control"
                  autocomplete="off"
                  v-on:change="trigger()"
                />
              </td>
              <td width="150px">
                <select class="form-control" v-model="tipo">
                  <option value="1">00:00 AM</option>
                  <option value="2">06:00 AM</option>
                </select>
              </td>
              <td>
                <button
                  class="btn btn-warning"
                  type="submit"
                  v-on:click="getReporteEquipos"
                >
                  Generar
                </button>
              </td>
              <td>
                <button
                  class="btn btn-success"
                  type="submit"
                  v-on:click="sendToExcel"
                >
                  Exportar
                </button>
              </td>
              <td>
                <div v-if="loading">
                  <img src="dist/img/kubber-loading.gif" style="width: 30px" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div id="reporte">
        <div class="report-titulo font-oswald">
          <table width="100%">
            <tbody>
              <tr>
                <th class="50%" colspan="2" style="vertical-align: top">
                  REPORTE
                </th>
                <th class="text-right">CANTIDAD TOTAL</th>
                <th class="text-right">IMPORTE TOTAL</th>
              </tr>
              <tr>
                <td class="50%" colspan="2" style="font-size: 24px">
                  <span class="color-primary">{{ this.fechaInicio }}</span> a
                  <span class="color-primary">{{ this.fechaFin }}</span>
                </td>
                <td class="text-right">
                  <div class="color-primary" style="font-size: 24px">
                    {{ GLOBAL.FORMATO_NUMBER(cantidadGalonaje) }}
                  </div>
                </td>
                <td class="text-right">
                  <div class="color-primary" style="font-size: 24px">
                    {{ GLOBAL.FORMATO_MONEY(totalVentas) }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <hr />
        <div>
          <table width="100%" class="table table-sm font-oswald font-14">
            <tbody>
              <tr>
                <th class="bg-kubber">PLU</th>
                <th class="bg-kubber">PRODUCTO</th>
                <th class="bg-kubber text-right" width="20%">CANTIDAD</th>
                <th class="bg-kubber text-right" width="25%">TOTAL</th>
                <th class="bg-kubber text-right" width="15%">%VENTA</th>
              </tr>

              <!-- Sección para origen_id = 8 (Ventas de Combustible) -->
              <tr>
                <th colspan="5">VENTA DE COMBUSTIBLE</th>
              </tr>
              <tr
                v-for="item in itemsOrigen8"
                :key="`origen8-${item.producto_plu}`"
              >
                <td>COD:{{ item.producto_plu }}</td>
                <td>{{ item.producto_nombre }}</td>
                <td class="text-right">
                  {{ GLOBAL.FORMATO_NUMBER(item.cantidad) }}
                </td>
                <td class="text-right">
                  {{ GLOBAL.FORMATO_MONEY_BASIC(item.total) }}
                </td>
                <td class="text-right"></td>
              </tr>
              <!-- Fila de sumatoria para origen_id = 8 -->
              <tr>
                <td colspan="2"></td>
                <td class="text-right text-bold">
                  {{ GLOBAL.FORMATO_NUMBER(sumCantidadOrigen8) }}
                </td>
                <td class="text-right text-bold">
                  {{ GLOBAL.FORMATO_MONEY_BASIC(sumTotalOrigen8) }}
                </td>
                <td></td>
              </tr>

              <!-- Sección para origen_id = 6 -->
              <tr>
                <th colspan="5">VENTA DE CANASTILLA</th>
              </tr>
              <tr
                v-for="item in itemsOrigen6"
                :key="`origen6-${item.producto_plu}`"
              >
                <td>COD:{{ item.producto_plu }}</td>
                <td>{{ item.producto_nombre }}</td>
                <td class="text-right">
                  {{ GLOBAL.FORMATO_NUMBER(item.cantidad) }}
                </td>
                <td class="text-right">
                  {{ GLOBAL.FORMATO_MONEY_BASIC(item.total) }}
                </td>
                <td class="text-right"></td>
              </tr>
              <!-- Fila de sumatoria para origen_id = 6 -->
              <tr>
                <td colspan="2"></td>
                <td class="text-right text-bold">
                  {{ GLOBAL.FORMATO_NUMBER(sumCantidadOrigen6) }}
                </td>
                <td class="text-right text-bold">
                  {{ GLOBAL.FORMATO_MONEY_BASIC(sumTotalOrigen6) }}
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
        <hr />
        <table
          width="100%"
          class="table table-sm font-oswald font-14"
          v-for="item in reporte.mangueras"
          :key="item"
        >
          <tbody>
            <tr>
              <th width="100px" class="bg-kubber">
                <i class="fa-solid fa-gas-pump"></i>
              </th>
              <th class="bg-kubber">PRODUCTO</th>
              <th width="100px" class="bg-kubber text-right">PRECIO</th>
              <th width="100px" class="bg-kubber text-right">CNT.</th>
              <th width="150px" class="bg-kubber text-right">TOTAL</th>
              <th width="100px" class="bg-kubber text-right">%VENTA</th>
            </tr>
            <tr v-for="val of item" :key="val">
              <td>M{{ val.manguera }}</td>
              <td>{{ val.producto_nombre }}</td>
              <td class="text-right">
                {{ GLOBAL.FORMATO_MONEY_BASIC(val.precio) }}
              </td>
              <td class="text-right">
                {{ GLOBAL.FORMATO_NUMBER(val.cantidad) }}
              </td>
              <td class="text-right">
                {{ GLOBAL.FORMATO_MONEY_BASIC(val.total) }}
              </td>
              <td class="text-right"></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td class="text-right">TOTAL</td>
              <td class="text-right">
                {{ GLOBAL.FORMATO_NUMBER_BASIC(recalculeCantidad(item)) }}
              </td>
              <td class="text-right">
                {{ GLOBAL.FORMATO_MONEY_BASIC(recalculeTotal(item)) }}
              </td>
              <td class="text-right"></td>
            </tr>
          </tbody>
        </table>
        <br />
      </div>
      <div v-if="!permiso_lista">
        {{ this.person.nombre }}, {{ this.GLOBAL.MENSAJE.SIN_AUTORIZACION }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import GLOBAL from "../../Global.js";
import ReporteService from "../../service/ReporteService";

export default {
  components: {},
  data() {
    return {
      GLOBAL,
      table: null,
      reporteService: null,
      person: null,
      mostrarEDS: true,
      permiso_lista: false,
      loading: true,
      tipo: 2,
      reporte: {
        general: [], // Inicializar como un array vacío
      },
      fechaInicio: "",
      fechaFin: "",
      cantidadGalonaje: 0,
      totalVentas: 0,
    };
  },
  computed: {
    itemsOrigen8() {
      return this.reporte.general
        ? this.reporte.general.filter((item) => item.origen_id === 8)
        : [];
    },
    itemsOrigen6() {
      return this.reporte.general
        ? this.reporte.general.filter((item) => item.origen_id === 6)
        : [];
    },
    sumCantidadOrigen8() {
      return this.itemsOrigen8.reduce((sum, item) => sum + item.cantidad, 0);
    },
    sumCantidadOrigen6() {
      return this.itemsOrigen6.reduce((sum, item) => sum + item.cantidad, 0);
    },
    sumTotalOrigen8() {
      return this.itemsOrigen8.reduce((sum, item) => sum + item.total, 0);
    },
    sumTotalOrigen6() {
      return this.itemsOrigen6.reduce((sum, item) => sum + item.total, 0);
    },
  },
  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    this.permiso_lista = this.person.funciones.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );
    this.reporteService = new ReporteService();
  },
  mounted() {
    this.loading = false;
    var fecha = new Date();
    $("#fechainicio").val(
      fecha.getFullYear() +
        "-" +
        (fecha.getMonth() + 1 <= 9
          ? "0" + (fecha.getMonth() + 1)
          : fecha.getMonth() + 1) +
        "-" +
        (fecha.getDate() <= 9 ? "0" + fecha.getDate() : fecha.getDate())
    );

    $("#fechafinal").val(
      fecha.getFullYear() +
        "-" +
        (fecha.getMonth() + 1 <= 9
          ? "0" + (fecha.getMonth() + 1)
          : fecha.getMonth() + 1) +
        "-" +
        (fecha.getDate() <= 9 ? "0" + fecha.getDate() : fecha.getDate())
    );
    $("input[datatype='fecha']").datepicker();
  },
  methods: {
    recalculeTotal(valores) {
      let sum = 0;
      for (const i in valores) {
        sum += valores[i].total;
      }
      return sum;
    },

    recalculeCantidad(valores) {
      let sum = 0;
      for (const i in valores) {
        sum += valores[i].cantidad;
      }
      return sum;
    },

    refrescarFactura() {
      this.facturaKey += 1;
    },
    getReporteEquipos() {
      this.reporte = [];
      var tfechainicio = $("#fechainicio").val();
      var tfechafin;
      var tfechaFormatoMasUno = $("#fechafinal").datepicker("getDate");

      if (this.tipo == 1) {
        tfechainicio += " 00:00:00";
        tfechafin = GLOBAL.FORMATO_FECHA(tfechaFormatoMasUno) + " 23:59:59";
      } else {
        var numberOfMlSeconds = tfechaFormatoMasUno.getTime();
        var addMlSeconds = 24 * 60 * 60000;
        tfechaFormatoMasUno = new Date(numberOfMlSeconds + addMlSeconds);
        tfechainicio += " 06:00:00";
        tfechafin = GLOBAL.FORMATO_FECHA(tfechaFormatoMasUno) + " 05:59:59";
      }

      this.fechaInicio = tfechainicio;
      this.fechaFin = tfechafin;

      this.loading = true;

      this.cantidadGalonaje = 0;
      this.totalVentas = 0;
      this.reporteService
        .corterTurno(this.person, this.fechaInicio, this.fechaFin, this.tipo)
        .then((data) => {
          this.reporte = data;
          console.log(this.reporte);
          for (const i in this.reporte.general) {
            this.cantidadGalonaje =
              this.cantidadGalonaje + this.reporte.general[i].cantidad;
            this.totalVentas = this.totalVentas + this.reporte.general[i].total;
          }
          this.loading = false;
        });
    },

    sendToExcel() {
      // Obtener el contenido HTML de la tabla
      const tableHTML = document.querySelector("#reporte").outerHTML;

      // Endpoint de la API
      const url = GLOBAL.API_SEND_HTML_EXCEL;

      // Definir el nombre del archivo
      const fileName = "reporte_corte.xlsx"; // Puedes generar dinámicamente el nombre aquí

      // Realizar la solicitud POST
      axios
        .post(url, tableHTML, {
          responseType: "blob", // Importante para manejar archivos binarios
          headers: {
            "Content-Type": "text/html", // Enviar como HTML
            "Access-Control-Allow-Origin": "*",
            Authorization: "Basic " + this.person.token, // Incluye tu token si es necesario
            Environment: this.person.empresas, // Otros encabezados necesarios
            "File-Name": fileName, // Encabezado personalizado con el nombre del archivo
          },
        })
        .then((response) => {
          // Crear un enlace para descargar el archivo
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName; // Usar el mismo nombre aquí
          link.click();
          window.URL.revokeObjectURL(link.href); // Limpiar la URL del objeto
        })
        .catch((error) => {
          console.error("Error al generar el archivo Excel:", error);
        });
    },
  },
};
</script>
